import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('fin_token');
      localStorage.removeItem('fin_user');
      window.location.href = '/';
    }
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  }
);

export default api;
